import { render, staticRenderFns } from "./ExcelSiparisCek.vue?vue&type=template&id=18fba68e"
import script from "./ExcelSiparisCek.vue?vue&type=script&lang=js"
export * from "./ExcelSiparisCek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports